var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCameraWhite = function SvgCameraWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5451 16.9245H2.45489C1.3797 16.9245 0.5 16.0448 0.5 14.9696V5.54852C0.5 4.47333 1.3797 3.59363 2.45489 3.59363H16.5451C17.6203 3.59363 18.5 4.47333 18.5 5.54852V14.9696C18.5 16.0448 17.6203 16.9245 16.5451 16.9245ZM2.45489 5.09739C2.20677 5.09739 2.00376 5.30039 2.00376 5.54852V14.9696C2.00376 15.2177 2.20677 15.4207 2.45489 15.4207H16.5451C16.7932 15.4207 16.9962 15.2177 16.9962 14.9696V5.54852C16.9962 5.30039 16.7932 5.09739 16.5451 5.09739H2.45489Z",
    fill: "#F6F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50003 14.2403C7.30454 14.2403 5.52258 12.4583 5.52258 10.2628C5.52258 8.06736 7.30454 6.2854 9.50003 6.2854C11.6955 6.2854 13.4775 8.06736 13.4775 10.2628C13.4775 12.4583 11.6955 14.2403 9.50003 14.2403ZM9.50003 7.78916C8.13912 7.78916 7.02634 8.90194 7.02634 10.2628C7.02634 11.6237 8.13912 12.7365 9.50003 12.7365C10.8609 12.7365 11.9737 11.6237 11.9737 10.2628C11.9737 8.90194 10.8684 7.78916 9.50003 7.78916Z",
    fill: "#F6F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7368 2.39817H6.26311C5.84958 2.39817 5.51123 2.05982 5.51123 1.64629C5.51123 1.23276 5.84958 0.894409 6.26311 0.894409H12.7368C13.1503 0.894409 13.4887 1.23276 13.4887 1.64629C13.4887 2.05982 13.1503 2.39817 12.7368 2.39817Z",
    fill: "#F6F8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCameraWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera-white.005ccc41.svg";
export { ForwardRef as ReactComponent };